import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import { Status } from '@/models/status.model';
import EdInputModel from '@/models/ed-input.model';

@Component({
  name: 'ed-select-template'
})
export default class EdSelectTemplateComponent extends Vue {

  /* Props */
  @Prop() readonly params: any;

  public selectedTemplateId = null;
  public status: Status = new Status();
  formattedTemplates: any = [];

  closeModal() {
    this.selectedTemplateId.value = null;
    this.$EdModal.closeModal();
  }

  selectTemplate() {
    let selectedTemplateId = this.selectedTemplateId.value;
    this.params.selectTemplate(selectedTemplateId);
    this.resetValue();
    return
  }

  get isValidField() {
    return !!this.selectedTemplateId?.value;
  }

  resetValue(): void {
    this.selectedTemplateId =  EdInputModel('selectedTemplateId', '' );
  }

  async getCourseTemplates(status: Status) {
    try {
      status.setLoading();
      let templates = await this.$CourseTemplates.Services.getMyCourseTemplates();

      this.formattedTemplates = templates?.courseTemplates?.map(t => {
        return {
          value: t.id,
          text: t.title
        }
      });
      status.setLoad();
    } catch(err) {
      status.setError();
    }
  }

  created() {
    this.getCourseTemplates(this.status);
  }

  mounted() {
  this.resetValue();
  }
}